module.exports = __webpack_public_path__ + "img/icon-pin.413814e0.svg";